import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'
import Login from '@/views/Login'
import Stats from '@/views/Stats'
import Weeks from '@/components/Weeks'

Vue.use(VueRouter)

function hasLocalStorage() {
  return (localStorage.getItem('athlete')
         && localStorage.getItem('activitiesRaw')
         && localStorage.getItem('activitiesOverTime')) ? true : false
}

const routes = [
  {
    path: '/',
    name: 'Login',
    component: Login,
    beforeEnter: (to, from, next) => {
      if (hasLocalStorage()) {
        next({ path: '/stats' })
      } else {
        next()
      }
    }
  },
  {
    path: '/authorize',
    beforeEnter: async (to, from, next) => {
      if (to.query.code) {
        console.log(`Auth Code: ${to.query.code}`)
        await store.dispatch('fetchStravaAuth', to.query.code)
        next({ path: '/stats' })
      }
    }
  },
  {
    path: '/stats',
    name: 'Stats',
    component: Stats,
    beforeEnter: async (to, from, next) => {
      if (hasLocalStorage()) {
        store.dispatch('updateFromLocalStorage')
        next()
      } else {
        await store.dispatch('getStravaActivities')
        next()
      }
    }
  },
  {
    path: '/weeks',
    name: 'Weeks',
    component: Weeks,
    beforeEnter: async (to, from, next) => {
      if (hasLocalStorage()) {
        store.dispatch('updateFromLocalStorage')
        next()
      } else {
        await store.dispatch('getStravaActivities')
        next()
      }
    }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
